import { render, staticRenderFns } from "./OstDataSelector.vue?vue&type=template&id=a940db00&scoped=true"
import script from "./OstDataSelector.vue?vue&type=script&lang=js"
export * from "./OstDataSelector.vue?vue&type=script&lang=js"
import style0 from "./OstDataSelector.vue?vue&type=style&index=0&id=a940db00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a940db00",
  null
  
)

export default component.exports